import {
  messageId,
  PropertyMeta,
  ValueObjectMetaNumber,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.number().min(1).max(12);
const savedMinimalSchema = z.number().min(1).max(12);
const schema = z.number().min(1).max(12);
const savedSchema = z.number().min(1).max(12);
const jsonSchema = z.number();
/**
 * 月(値オブジェクト)のメタデータ。
 *
 * 月。 */
export const monthMeta = new ValueObjectMetaNumber(
  "Month",
  "\u6708",
  messageId("lbl.\u6708"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
